/**
 * Knowledge-base label helpers shared by the sources table and the
 * retrieval panel, so a source type is never translated in one place and
 * left as a raw backend string in the other.
 */

/** `sourceType` on a retrieved chunk is a plain string (it can name a value
 * the frontend's `KbSource['type']` union doesn't know about yet), so this
 * accepts any string rather than the narrower union. */
export const kbSourceTypeLabelKey = (type: string): string => `dashboard.kb.type.${type}`;
